/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconDocumentDone = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--documentdone',
    className,
  )

  return (
    <IconBase className={classes} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"{...rest}><circle cx="20" cy="20" r="20" fill="#86BD24"/><path className="path1" fillRule="evenodd" clip-rule="evenodd" d="M17.526 27c-.295 0-.577-.121-.786-.337l-5.374-5.548a1.178 1.178 0 0 1-.077-1.626 1.09 1.09 0 0 1 1.651 0l4.586 4.737 9.534-9.848a1.09 1.09 0 0 1 1.574-.08 1.178 1.178 0 0 1 0 1.706L18.326 26.652c-.21.223-.499.348-.8.348z" fill="#fff"/></IconBase>
  )
}

IconDocumentDone.propTypes = {
  className: PropTypes.string,
}

export default IconDocumentDone
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconDocumentDone.js